import getVideoId from 'get-video-id';
import axios from "axios";

export default {
    data: () => {
        return {
            id: null,
            thumbnail: null,
            duration: null
        }
    },
    methods: {
        getVideoInfos(video) {
            this.id = getVideoId(video.url);
            if (video.type === 'youtube') {
                this.thumbnail = 'https://img.youtube.com/vi/' + this.id.id + '/hqdefault.jpg';
            } else if (this.video.type === 'vimeo') {
                let url = "https://vimeo.com/api/oembed.json?url=" + video.url + '&width=1920&height=1080';
                axios.get(url).then(response => {
                    if (response.data) {
                        this.thumbnail = response.data.thumbnail_url;
                        this.duration = response.data.duration;
                    }
                }).catch(function (error) {
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                })
            }
        }
    }
}
